import React, { Component } from "react";
import * as handler from "../components/utils/handler";
import { DataService } from "../services/data.service";
import ModalHead from "./../components/modal-head/modalHead";
import PrimaryButton from "../components/utils/primaryButton";
import swalAlert from "sweetalert";

const queryString = require("query-string");

const defaultLanguage = window["app-config"].defaultLang;
const runApp = window["app-config"].runApp;
const UI = window["app-config"].ui.userDetailsScreen;

class Signup extends Component {
  state = {
    lang: {},
    firstName: null,
    lastName: null,
    email: null,
    password: null,
    dataLoaded: false,
  };

  componentDidMount() {
    this.setState({ lang: handler.setTranslations() });
  }

  ShowSignupError = async () => {
    let resp = await swalAlert(
      this.state.lang.Attention,
      this.state.lang.SignupEmptyFieldsMsg,
      "warning",
      {
        buttons: {
          ok: {
            text: this.state.lang.Ok,
            value: "ok",
          },
        },
      }
    );
    return resp;
  };

  onSignupClick = () => {
    if (
      this.state.firstName === null ||
      this.state.surName === null ||
      this.state.emailAddress === null ||
      this.state.password === null
    ) {
      this.ShowSignupError();
    } else {
      console.log(
        "DATA: ",
        this.state.firstName,
        " ",
        this.state.surName,
        " ",
        this.state.emailAddress,
        " ",
        this.state.password
      );
      console.log("User Added...");
      this.props.history.push("/login-user");
    }
  };

  onFirstNameChange = (e) => {
    this.setState({ firstName: e.target.value });
  };

  onSurNameChange = (e) => {
    this.setState({ lastName: e.target.value });
  };

  onEmailChange = (e) => {
    this.setState({ email: e.target.value });
  };

  onPasswordChange = (e) => {
    this.setState({ password: e.target.value });
  };

  render() {
    return (
      <>
        <div className="container">
          <div className="sl__modal">
            <ModalHead
              address={""}
              heading={this.state.lang.StaticHeaderHeading}
            />

            <div className="sl__modal-inner">
              <div className="sl__modal--content">
                <h2 style={{ color: UI.headingColor }}>
                  {this.state.lang.Signup}
                </h2>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col"></div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: UI.fColor }}
                    >
                      {this.state.lang.FirstName}
                      <span
                        className="estaric"
                        style={{ color: UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onFirstNameChange}
                      onBlur={this.sendSignupDetailsToParent}
                      type="text"
                      name="username"
                      maxLength={20}
                      placeholder={this.state.lang.FirstNamePlaceholder}
                      id="firstname-field"
                      className="sl__modal_form--input validate-text firstname"
                    />
                  </div>
                  <div className="sl__modal_form-col"></div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col"></div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: UI.fColor }}
                    >
                      {this.state.lang.SurName}
                      <span
                        className="estaric"
                        style={{ color: UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onSurNameChange}
                      onBlur={this.sendSignupDetailsToParent}
                      type="text"
                      name="username"
                      maxLength={20}
                      placeholder={this.state.lang.SurNamePlaceholder}
                      id="firstname-field"
                      className="sl__modal_form--input validate-text firstname"
                    />
                  </div>
                  <div className="sl__modal_form-col"></div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col"></div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: UI.fColor }}
                    >
                      {this.state.lang.EmailAddress}
                      <span
                        className="estaric"
                        style={{ color: UI.requiredEstaricColor }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onEmailChange}
                      onBlur={this.sendSignupDetailsToParent}
                      type="text"
                      name="username"
                      maxLength={20}
                      placeholder={this.state.lang.EmailAddressPlaceHolder}
                      id="firstname-field"
                      className="sl__modal_form--input validate-text firstname"
                    />
                  </div>
                  <div className="sl__modal_form-col"></div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col"></div>

                  <div className="sl__modal_form-col">
                    <label
                      className="sl__modal_form--label"
                      style={{ color: UI.fColor }}
                    >
                      {this.state.lang.password}
                      <span
                        className="estaric"
                        style={{
                          color: UI.requiredEstaricColor,
                        }}
                      >
                        *
                      </span>
                    </label>
                    <input
                      onChange={this.onPasswordChange}
                      onBlur={
                        this.state.isLoggin === false
                          ? this.sendSignupDetailsToParent
                          : null
                      }
                      type="password"
                      name="password"
                      maxLength={20}
                      placeholder={this.state.lang.passwordPlaceholder}
                      id="surname-field"
                      className="sl__modal_form--input validate-text"
                    />
                  </div>

                  <div className="sl__modal_form-col"></div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col">
                    <PrimaryButton
                      bgColor={"#1428a0"}
                      onClick={this.onSignupClick}
                    >
                      {/* {this.state.dataLoaded === false ? (
                        <i className="fa fa-spinner fa-spin"></i>
                      ) : null} */}
                      &nbsp;
                      {this.state.issueQrTicket === true
                        ? this.state.lang.TakeATicket
                        : this.state.isLoggin === true
                        ? this.state.lang.SignIn
                        : this.state.lang.SignupBtnText}
                    </PrimaryButton>
                  </div>
                </div>

                <div className="sl__modal_form-row">
                  <div className="sl__modal_form-col">
                    <a
                      onClick={() => {
                        this.props.history.push("login-user");
                      }}
                    >
                      {this.state.lang.LoginLink}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Signup;
